import { Route, Routes } from 'react-router-dom';

import { Navbar } from '../components/ui/Navbar';
import { TransactionPage } from '../pages/transaction/TransactionPage';
import { TransactionsProvider } from '../context/transactions/TransactionContext';
import { UsersPage } from '../pages/user/UsersPage';
import { WelcomenPage } from '../pages/welcomePage';
import { UsersProvider } from '../context/users/UserContext';
import { MerchantsProvider } from '../context/merchants/MerchantContext';
import { MerchantsPage } from '../pages/merchant/MerchantsPage';
import { MerchantPage } from '../pages/merchant/MerchantPage';
import { UserPage } from '../pages/user/UserPage';
import { BanksProvider } from '../context/bank/BankContext';
import { BanksPage } from '../pages/bank/BanksPage';
import { BankPage } from '../pages/bank/BankPage';
import { ApplicationsProvider } from '../context/applications/ApplicationContext';
import { ApplicationsPage } from '../pages/application/ApplicationsPage';
import { ApplicationPage } from '../pages/application/ApplicationPage';
import { GroupsProvider } from '../context/group/GroupContext';
import { GroupPage } from '../pages/group/GroupPage';
import { GroupsPage } from '../pages/group/GroupsPage';
import { GroupResourcePage } from '../pages/group/GroupResourcePage';
import { GroupUsersPage } from '../pages/group/GroupUserPage';
import { UserGroupPage } from '../pages/user/UserGroupPage';
import { ApprovalsPage } from '../pages/approve/ApprovalsPage';
import { ApprovalPage } from '../pages/approve/ApprovalPage';
import { ReportOnboardingPage } from '../pages/reports/report-onboarding';
import { ClassifierProvider } from '../context/classifier/ClassifierContext';
import { ClassifiersPage } from '../pages/classifier/ClassifiersPage';
import { ClassifierPage } from '../pages/classifier/ClassifierPage';
import { ClassifierValuesPage } from '../pages/classifier/ClassifierValuesPage';
import { ClassifierValuePage } from '../pages/classifier/ClassifierValuePage';
import { ClassifierFiPage } from '../pages/classifier/ClassifierFiPage';
import { BranchesPage } from '../pages/branch/BranchesPage';
import { BranchProvider } from '../context/branch/BranchContext';
import { BranchPage } from '../pages/branch/BranchPage';
import { ClassifierValueFiPage } from '../pages/classifier/ClassifierValueFiPage';
import { PayfacProvider } from '../context/payfac/PayfacContext';
import { PayfacsPage } from '../pages/payfac/PayfacsPage';
import { PayfacPage } from '../pages/payfac/PayfacPage';
import { ViewRequestPage } from '../pages/reports/ViewRequestPage';

export const DashboardRoutes = () => {
  return (

    <>

      <Navbar />

      <div className="" >
        <Routes>
          <Route
            path="/"
            element={<MerchantsProvider> <WelcomenPage /></MerchantsProvider>} />
          {/* Comercios */}
          <Route
            path="merchants"
            element={<ApplicationsProvider> <ApplicationsPage /> </ApplicationsProvider>} />

          <Route
            path="merchant"
            element={<ApplicationsProvider> <ApplicationPage /> </ApplicationsProvider>} />

          {/* Bancos */}
          <Route
            path="banks"
            element={<BanksProvider> <BanksPage /> </BanksProvider>} />

          <Route
            path="bank"
            element={<BanksProvider> <BankPage /> </BanksProvider>} />

          {/* Usuarios */}
          <Route
            path="users"
            element={<UsersProvider> <UsersPage /> </UsersProvider>} />

          <Route
            path="user"
            element={<BanksProvider><UsersProvider> <UserPage /> </UsersProvider></BanksProvider>} />


          <Route
            path="/user/group"
            element={<UsersProvider> <UserGroupPage /> </UsersProvider>} />




          {/* Transacciones */}
          <Route
            path="transactions"
            element={<TransactionsProvider><MerchantsProvider> <TransactionPage /> </MerchantsProvider> </TransactionsProvider>} />

          {/* Grupos */}
          <Route
            path="groups"
            element={<GroupsProvider> <GroupsPage /> </GroupsProvider>} />

          <Route
            path="group"
            element={<BanksProvider><GroupsProvider> <GroupPage /> </GroupsProvider></BanksProvider>} />

          <Route
            path="/group/permission"
            element={<GroupsProvider> <GroupResourcePage /> </GroupsProvider>} />

          <Route
            path="/group/user"
            element={<GroupsProvider> <GroupUsersPage /> </GroupsProvider>} />


          {/* Aprobaciones */}
          <Route
            path="approvals"
            element={<ApplicationsProvider> <ApprovalsPage /> </ApplicationsProvider>} />

          <Route
            path="approval"
            element={<ApplicationsProvider> <ApprovalPage /> </ApplicationsProvider>} />

          {/* Reportes */}
          <Route
            path="report-onboarding"
            element={<ApplicationsProvider> <ReportOnboardingPage /> </ApplicationsProvider>} />

          <Route
            path="report-onboarding/view"
            element={<ApplicationsProvider> <ViewRequestPage /> </ApplicationsProvider>} />

          {/* Classificadores */}
          <Route
            path="classifiers"
            element={<ClassifierProvider> <ClassifiersPage /> </ClassifierProvider>} />

          <Route
            path="classifier"
            element={<ClassifierProvider> <ClassifierPage /> </ClassifierProvider>} />

          <Route
            path="classifier/values"
            element={<ClassifierProvider> <ClassifierValuesPage /> </ClassifierProvider>} />

          <Route
            path="classifier/value"
            element={<ClassifierProvider> <ClassifierValuePage /> </ClassifierProvider>} />

          <Route
            path="classifier/fis"
            element={<ClassifierProvider> <ClassifierFiPage /> </ClassifierProvider>} />

          <Route
            path="classifier/value/fis"
            element={<ClassifierProvider> <ClassifierValueFiPage /> </ClassifierProvider>} />

          {/* Sucursales */}
          <Route
            path="branchs"
            element={<BranchProvider> <BranchesPage /> </BranchProvider>} />

          <Route
            path="branch"
            element={<BranchProvider> <BranchPage /> </BranchProvider>} />

          {/* Payfacs */}
          <Route
            path="payfacs"
            element={<PayfacProvider> <PayfacsPage /> </PayfacProvider>} />

          <Route
            path="payfac"
            element={<PayfacProvider> <PayfacPage /> </PayfacProvider>} />



        </Routes>
      </div>


    </>

  )
}